// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"80820dac724a5bf5116f","655":"b628b5845674a9c8fb8e"}[chunkId] + ".js";
};